module.exports = __webpack_public_path__ + "media/img/covers/profile-cover-5-355d8ea3175e50f1b9503a19ce78b95f.jpg";